import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    noDepots: translate({ id: 'globalStyles.depots.noDepots' }),
    depots: translate({ id: 'global.depots' }),
    on: translate({ id: 'global.on' }),
    off: translate({ id: 'global.off' }),
    onWithLabel: translate({ id: 'globalStyles.depots.onWithLabel' }),
  }))

  return api
}
